import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { BackButton, Button, Title } from '../../../../components/UI/ComponentsUI';
import ConfirmModalUI from '../../../../components/UI/ConfirmModalUI';
import SecurityService from '../../../../services/SecurityService';
import StockService from '../../../../services/StockService';
import { ENUMS } from '../../../../utils/constants';
import { onValueChange, validateInputsRequired } from "../../../../utils/handleChangeHooks";
import { isNullOrEmpty, showMessageToastCustom, translate } from '../../../../utils/util';
import DropMaterialArea from './DropMaterialArea';
import DropMaterialBarCode from './DropMaterialBarCode';
import DropMaterialPartNumber from './DropMaterialPartNumber';

const DropMaterial = (props) => {
    const pabReplanning = props.history?.location?.state?.pabReplanning;
    const area = props.history?.location?.state?.area;
    const barcode = props.history?.location?.state?.barcode;
    const partnumber = props.history?.location?.state?.partnumber;
    const quality = props.history?.location?.state?.quality;
    const dataParams = props.history?.location?.state?.dataParams

    const [openModal, setOpenModal] = useState(false);
    const [messageModal, setMessageModal] = useState({ task: false, message: '' });

    const [filter, setFilter] = useState({
        partNumber: dataParams?.partNumber || '',
        area: dataParams?.area || '',
        cim: dataParams?.cim || '',
        print: 'C',
        resourceId: props.user.resource || '',
        quantity: !pabReplanning ? dataParams?.qtd || '' : 0,
        justification: '',
        masterCim: 'N'
    });


    useEffect(() => {
        let filterState = filter;
        if (props.justifications?.items && props.justifications?.items.length > 0) {
            filterState.justification = props.justifications?.items?.filter(x => x.justificationTypeId === 6)[0]?.description;
            setFilter({ ...filterState });
        }
        // eslint-disable-next-line
    }, [props.justifications])

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const getOperation = () => {
        let operation = '';
        if (partnumber) {
            operation = ENUMS.eStockOperation.Partnumber.value;
        } else if (barcode && !pabReplanning) {
            operation = ENUMS.eStockOperation.BarCode.value;
        } else {
            if (quality) {
                operation = ENUMS.eStockOperation.Quality.value;
            }
            else {
                if (pabReplanning) {
                    operation = ENUMS.eStockOperation.Pab.value;
                } else {
                    operation = ENUMS.eStockOperation.Area.value;
                }
            }
        }
        return operation;
    }

    const setResource = () => {
        if (filter.print === ENUMS.ePrintTypes.Click.value && !isNullOrEmpty(props.user?.resourceObj?.clickResourceName)) {
            return props.user?.resourceObj?.clickResourceName;
        }

        return props.user?.resourceObj?.name;
    }

    const validateResource = () => {
        if (!props.user?.resourceObj && filter.print !== ENUMS.ePrintTypes.NotPrint.value) {
            showMessageToastCustom(translate('warning', 'general'), translate('select-resource', 'validations'), 3000, 'mdi mdi-alert-circle-outline red-text');
            return false;
        }

        return true;
    }

    const sendMaterial = () => {
        if (validateInputsRequired('formInput') && validateResource) {
            var filterobj = {};
            Object.assign(filterobj, filter);
            filterobj.operation = getOperation();
            filterobj.resource = setResource();
            filterobj.printer = props.user.printer;
            props.confirm(
                filterobj,
                () => {
                    props.history.go(-1);
                },
                (message, task) => {
                    messageModal.task = task;
                    messageModal.message = message
                    setMessageModal({ ...messageModal });
                    setOpenModal(true);
                }

            );
        }
    }

    const closeModal = () => {
        setOpenModal(false);
        messageModal.task = false;
        messageModal.message = '';
        setMessageModal({ ...messageModal });
        if (messageModal.task) {
            props.history.go(-1);
        }
    }

    const renderTitle = () => {
        let text = '';
        if (partnumber) {
            text = translate('stock:write-off-by-partnumber')
        } else if (barcode) {
            text = translate('stock:write-off-by-barcode')
        } else {
            text = translate('stock:write-off-by-location')
        }
        return text;
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <Title icon="mdi mdi-clipboard-check-outline" label={renderTitle()} />
                </div>
            </div>
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <div className="card">
                        <div id="formInput" className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            {
                                (barcode || quality) &&
                                <DropMaterialBarCode
                                    disable={props.history?.location?.state?.disable}
                                    onChange={onChange}
                                    filter={filter}
                                    setFilter={setFilter}
                                    pabReplanning={pabReplanning}
                                />
                            }
                            {
                                partnumber &&
                                <DropMaterialPartNumber
                                    onChange={onChange}
                                    filter={filter}
                                    pabReplanning={pabReplanning}
                                />
                            }
                            {area &&
                                <DropMaterialArea
                                    onChange={onChange}
                                    filter={filter}
                                    pabReplanning={pabReplanning}
                                />
                            }
                            <div className="row">
                                <Button
                                    full="true"
                                    onClick={() => sendMaterial()}
                                    text={translate('confirm', 'general')}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ConfirmModalUI
                open={openModal}
                id="messageModalErro"
                data={{
                    title: translate('validations:attention'), message: <>
                        <span className="title col s12" style={{ color: 'red' }}>{
                            messageModal.message}</span>
                    </>
                }}
                showCancel={false}
                onConfirm={closeModal}
                onClose={closeModal}
                btnConfirm={translate('close', 'general')}
            />
        </div>

    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        resources: state.logisticsResourceReducer.list,
        justifications: state.justificationReducer.justifications
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        confirm: (model, callback, callbackError) => {
            dispatch(StockService.confirm(model, callback, callbackError));
        },
        setResource: (resource) => {
            dispatch(SecurityService.setResource(resource));
        },
        setPrinter: (printer) => {
            dispatch(SecurityService.setPrinter(printer));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(DropMaterial));